<template>
  <tbody :id="id">
    <tr>
      <th colspan="6" class="empty">Razem</th>
      <td class="number">{{ money(total.nettoValue)}}</td>
      <td class="number">{{ money(total.vatValue) }}</td>
      <td class="number">{{ money(total.bruttoValue) }}</td>
    </tr>
  </tbody>
</template>

<script>
import accounting from 'accounting'

export default {
  props: ['products', 'id'],
  computed: {
    total () {
      const total = { nettoValue: 0, vatValue: 0, bruttoValue: 0 }
      this.products.forEach(s => {
        total.nettoValue += s.nettoValue
        total.vatValue += s.vatValue
        total.bruttoValue += s.bruttoValue
      })
      return total
    }
  },
  methods: {
    money (value) {
      return accounting.formatNumber(value / 100, 2, '.', ',')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~assets/common.scss";

td,th {
  padding: 0.4em;
  position: relative;
  font-weight: bold;
  border-bottom: none;

  &.number {
    text-align: right;
  }
}
th {
  text-align: right;
}
</style>



/** WEBPACK FOOTER **
 ** InvoiceTotal.vue?ab4d80f0
 **/